module.exports = __webpack_public_path__ + "img/pw_cocaine.c74225dd.png";